<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.class_accel_edit' : 'content.class_accel_create')" />
    <v-row>
      <v-col>
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('content.class_from')" :validator="$v.form.gradeIdFrom">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-model="form.gradeIdFrom"
                        v-bind="attrs"
                        :loading="loading"
                        item-value="gradeId"
                        item-text="name"
                        :items="class_level"
                        :label="$t('content.class_from')"
                        @change="getLevelTo(form.gradeIdFrom)"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <form-group :name="$t('content.class_to')" :validator="$v.form.gradeIdTo">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-model="form.gradeIdTo"
                        v-bind="attrs"
                        :loading="loading"
                        item-value="gradeId"
                        item-text="name"
                        :items="class_level1"
                        :label="$t('content.class_to')"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('form.status')" :validator="$v.form.status">
                    <template slot-scope="{ attrs }">
                      <v-select :items="status" :label="$t('form.status')" v-bind="attrs" v-model="form.status" width="100">
                        <template #item="{item}">
                          {{ $t(item.text) }}
                        </template>
                        <template #selection="{item}">
                          {{ $t(item.text) }}
                        </template>
                      </v-select>
                    </template>
                  </form-group>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
            <v-btn color="primary" :loading="loading" class="btn-primary-custom" type="submit">
              {{ $t(edit ? 'save' : 'submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'CreateEditClassAccel',
  components: {
    BaseTitle
  },
  validations: function() {
    return {
      form: {
        gradeIdFrom: { required },
        gradeIdTo: { required },
        status: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      status: 'Reference/itemStatus',
      currentRole: 'Auth/currentRole'
    })
  },
  data: () => ({
    form: {
      gradeIdFrom: '',
      gradeIdTo: '',
      status: ''
    },
    class_level: [],
    class_level1: [],
    edit: false,
    loading: false,
    currentUserId: null,
    search: ''
  }),
  methods: {
    getData() {
      this.$store.dispatch('ClassAccel/fetchDetail', this.$route.params.id).then(res => {
        this.$store.dispatch('ClassLevel/fetchDetail', res.gradeIdFrom).then(ras => {
          this.getLevel(ras);
        });

        this.getLevelTo(res.gradeIdFrom);

        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });
      });
    },
    getLevel(to) {
      this.loading = true;
      this.$store
        .dispatch('ClassAccel/gradeFrom', {
          search: this.search
        })
        .then(res => {
          const fromArr = res;
          if (this.edit) {
            fromArr.push({
              gradeId: to.gradeId,
              name: to.name
            });
          }
          // console.info(res);
          // var index = fromArr.findIndex(function(o) {
          //   return o.gradeId === to;
          // });
          // if (index !== -1) fromArr.splice(index, 1);

          this.class_level = fromArr;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.loading = false));
    },
    getLevelTo(to) {
      this.loading = true;
      this.$store
        .dispatch('ClassAccel/gradeTo', to)
        .then(res => {
          const fromArr = res;
          // var index = fromArr.findIndex(function(o) {
          //   return o.gradeId === to;
          // });
          // if (index !== -1) fromArr.splice(index, 1);

          this.class_level1 = fromArr;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.loading = false));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...this.form };
      this.$store
        .dispatch(`ClassAccel/${this.edit ? 'update' : 'save'}`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'ClassAccelSuccessUpdate' : 'ClassAccelSuccess' }))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    back() {
      this.$router.push({ name: 'ClassAccelIndex' });
    },
    preventNav(event) {
      if (!this.edit || !this.$v.$anyDirty) return;
      event.preventDefault();
      event.returnValue = '';
    }
  },
  created() {
    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    } else {
      this.getLevel();
      this.hasLoad = true;
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('beforeunload', this.preventNav));
  },
  beforeRouteLeave(to, from, next) {
    if (!this.edit && this.$v.$anyDirty && this.$v.$invalid) {
      if (!window.confirm(this.$t('alert.leave_message'))) {
        return;
      }
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
.manual {
  color: #fa6400;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
